import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { Info } from "lucide-react";
import { PolymorphicPlayerCard } from "@/services/bedrock";
import { Alert } from "@/components/ui/alert";
import PlayerCardField from "./Fields/PlayerCardField";
import CustomTitleField from "./Fields/CustomTitleField";
import { PlayerCardSettingsContext } from "../../../Contexts";
import RecordSelector from "../../../RecordSelector";

interface FormWidgetSettingsProps {
  index: number;
}

const FormWidgetSettings: React.FC<FormWidgetSettingsProps> = ({ index }) => {
  const { Forms } = useContext(PlayerCardSettingsContext);
  const { getValues } = useFormContext<PolymorphicPlayerCard>();
  const isTemplate = getValues("isTemplate");

  return (
    <div className="playerCardWidgetOwner playerCardForm">
      <PlayerCardField
        index={index}
        fieldName="formId"
        fieldLabel="Form"
        rules={{ required: "This is required." }}
        component={RecordSelector}
        context={Forms}
      />
      <CustomTitleField index={index} />
      {isTemplate && (
        <Alert>
          <Info />
          <Alert.Description>
            This widget is hidden on Player Cards for Players who aren't eligible to fill out this form.
          </Alert.Description>
        </Alert>
      )}
    </div>
  );
};
export default FormWidgetSettings;
